import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: "خانه",
        component: () => import('@/Pages/HomePage'),
        meta: {transition: 'zoom'},
    },
    {
        // Old home URL; the home page canonical is now "/".
        path: "/HomePage",
        redirect: '/',
    },
    {
        path: "/servicePage",
        name: "خدمات",
        component: () => import('@/Pages/ServicePage'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/aboutUs",
        name: "درباره ما",
        component: () => import('@/Pages/AboutUs'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/termsAndConditions",
        name: "قوانین و مقررات",
        component: () => import('@/Pages/TermsAndConditions'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/contactUs",
        name: "تماس با ما",
        component: () => import('@/Pages/ContactUs'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/ServiceDetails/:id/:title?",
        name: "ServiceDetails",
        component: () => import('@/Pages/ServiceDetails'),
        meta: {transition: 'zoom'},
    },

    {
        path: "/BlogPostsDetails/:id/:title?",
        name: "blogPostsDetails",
        component: () => import('@/Pages/BlogPostsDetails'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/ServiceDetails2/:id/:title?",
        name: "serviceDetails2",
        component: () => import('@/Pages/ServiceDetails2'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/BlogPosts",
        name: "مقالات",
        component: () => import('@/Pages/BlogPosts'),
        meta: {transition: 'zoom'},
    },
/*    {
        path: "/CVSubmit",
        name: "همکاری با ما",
        component: () => import('@/Pages/CVSubmit'),
        meta: {transition: 'zoom'},
    },*/
    {
        path: "/Services",
        name: "خدمات پرتو گراد",
        component: () => import('@/Pages/TutorialsPage'),
        meta: {transition: 'zoom'},
    },
    {
        path: "/VideosPage",
        name: "ویدیوها",
        component: () => import('@/Pages/VideosPage'),
        meta: {transition: 'zoom'},
    },
    {
        path: "*",
        name: "notFound",
        component: () => import('@/Pages/NotFoundPage'),
        meta: {transition: 'zoom'},
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        return savedPosition || {x: 0, y: 0};
    },
});

export default router;
